import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../stores/Auth/Auth";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { Card, CardBody, Col, Container, Row, Alert } from "reactstrap";

const ValidateEmailMobile = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const { validateEmail } = useAuth((state) => state);
    const [isValidating, setIsValidating] = useState(true);
    const [validationStatus, setValidationStatus] = useState(null);

    useEffect(() => {
        if (token) {
            handleValidation();
        }
    }, [token]);

    const handleValidation = async () => {
        setIsValidating(true);
        try {
            await validateEmail({ token });
            setValidationStatus("success");
        } catch (error) {
            setValidationStatus("error");
        } finally {
            setIsValidating(false);
        }
    };

    const handleDownloadAndroid = () => {
        // Replace with your actual Google Play Store URL
        window.open("https://play.google.com/store/apps/details?id=io.clickorder.app.consumer", "_blank");
    };

    const handleDownloadIOS = () => {
        // Replace with your actual App Store URL
        window.open("https://apps.apple.com/us/app/clickorder-io/id6736413698", "_blank");
    };

    return (
        <ParticlesAuth>
            <div className="auth-page-content">
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div className="text-center mt-sm-5 mb-4 text-white-50">
                                <div>
                                    <h1 className="display-5 coming-soon-text">Email Validation</h1>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={5}>
                            <Card className="mt-4">
                                <CardBody className="p-4">
                                    <div className="text-center mt-2">
                                        {isValidating ? (
                                            <>
                                                <div className="mb-4">
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                </div>
                                                <h5 className="text-primary">Validating your email...</h5>
                                                <p className="text-muted">Please wait while we verify your account.</p>
                                            </>
                                        ) : validationStatus === "success" ? (
                                            <>
                                                <div className="mb-4">
                                                    <div className="avatar-lg mx-auto">
                                                        <div className="avatar-title bg-light text-success display-5 rounded-circle">
                                                            <i className="ri-checkbox-circle-fill"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <h4 className="text-success mb-3">Email Verified Successfully!</h4>
                                                <p className="text-muted mb-4">
                                                    Your email has been successfully verified. Download our mobile app to get started!
                                                </p>

                                                <div className="mt-4">
                                                    <h6 className="mb-3">Download the App</h6>

                                                    {/* Google Play Button */}
                                                    <button
                                                        onClick={handleDownloadAndroid}
                                                        className="btn btn-dark btn-lg w-100 mb-3"
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            gap: "12px",
                                                            borderRadius: "8px",
                                                        }}
                                                    >
                                                        <i className="ri-google-play-fill" style={{ fontSize: "24px" }}></i>
                                                        <div style={{ textAlign: "left" }}>
                                                            <div style={{ fontSize: "10px", opacity: 0.8 }}>GET IT ON</div>
                                                            <div style={{ fontSize: "16px", fontWeight: "600" }}>Google Play</div>
                                                        </div>
                                                    </button>

                                                    {/* Apple App Store Button */}
                                                    <button
                                                        onClick={handleDownloadIOS}
                                                        className="btn btn-dark btn-lg w-100"
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            gap: "12px",
                                                            borderRadius: "8px",
                                                        }}
                                                    >
                                                        <i className="ri-apple-fill" style={{ fontSize: "24px" }}></i>
                                                        <div style={{ textAlign: "left" }}>
                                                            <div style={{ fontSize: "10px", opacity: 0.8 }}>Download on the</div>
                                                            <div style={{ fontSize: "16px", fontWeight: "600" }}>App Store</div>
                                                        </div>
                                                    </button>
                                                </div>

                                                <div className="mt-4 text-center">
                                                    <p className="mb-0 text-muted">
                                                        <small>
                                                            <i className="ri-information-line me-1"></i>
                                                            Open the app on your mobile device to continue
                                                        </small>
                                                    </p>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="mb-4">
                                                    <div className="avatar-lg mx-auto">
                                                        <div className="avatar-title bg-light text-danger display-5 rounded-circle">
                                                            <i className="ri-close-circle-fill"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <Alert color="danger" className="text-start">
                                                    <h5 className="alert-heading">Validation Failed</h5>
                                                    <p className="mb-0">
                                                        The validation link is invalid or has expired. Please request a new verification email.
                                                    </p>
                                                </Alert>
                                            </>
                                        )}
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </ParticlesAuth>
    );
};

export default ValidateEmailMobile;
